type Size = "sm" | "md" | "lg";

export function Avatar({ name, initials, color, size = "md" }: { name: string; initials?: string; color: string; size?: Size }) {
  const cls = size === "sm" ? "avatar avatar--sm" : size === "lg" ? "avatar avatar--lg" : "avatar";
  const label = initials || name.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase() || "?";
  return (
    <span className={cls} style={{ background: color }} aria-label={name}>{label}</span>
  );
}
